import { queryOptions } from '@tanstack/react-query';
import type { DashboardParams } from '../model/schema';
import { dashboardApi } from './dashboard-api';

/** Query-key factory for the dashboard slice. */
export const dashboardKeys = {
  all: ['admin-dashboard'] as const,
  summary: (params?: DashboardParams) =>
    [
      ...dashboardKeys.all,
      'summary',
      params?.tab ?? 'eats',
      params?.period ?? 'week',
      params?.date ?? '',
    ] as const,
};

export const dashboardQueries = {
  summary: (params?: DashboardParams) =>
    queryOptions({
      queryKey: dashboardKeys.summary(params),
      queryFn: () => dashboardApi.getSummary(params),
      staleTime: 30_000,
    }),
};
